<template>
  <div class="race-question">
    <modal name="email" @before-close="onClose">
      <div style="padding: 20px;">
        <span> {{runner.runner?runner.runner.user.email:null}}</span>
          
              <br/>
           <input type = "text" v-model="newemail" id="newemail" maxlength="255" name="newemail" Placeholder="" style="width: 50%;"> 
          
        <div>
              <br/>
            <button class="btn btn--primary"  v-on:click="Save(newemail)" style="float:none">Save</button>
        </div>
      </div>
    </modal>  
  </div>
  
</template>

<script>
  import RunnersByRaceService from '../../../services/runnersByRace'
  import { db } from '../../../firebase'

  export default {
    name: 'edit-email',
    data: () => ({
        newemail:'',
        finishDate: ''
    }),
    props:{
            runner: {
                type:Object
            },
            show:false,
        },
    // firebase: {
    //   ${this.$fbDbEntry}: db.ref('${this.$fbDbEntry}')
    // },
    methods: {
        onClose() {
                this.$emit('closed', true)
        },
        openEditModal() {
          this.$modal.show('email')
        },
        Save (email) {
        let  that = this
          RunnersByRaceService.updateEmail(this.runner.runner.id, email).then((response) => {
            that.$emit('saved', response.data)
            that.$modal.hide('email')
            that.newemail = ''
          },
          (error) =>{
            console.log(error)
          })
        }
    },
    created() {
     this.$watch('show', function (val) {
      })
    },
    
    watch: {
        show(oldVal, newVal) {
            if(this.show){
             this.openEditModal()
            }
        }
    },
  }
</script>
<style>
  .edit {
      background: red;
      padding: 0px 12px 0px 12px;
      color: white;
      border-radius: 10px;
      border-width: 1px;
      font-weight: bold;
    }

    #newemail {
      height: 50px;
      border-radius: 10px;
      font-size: x-large;
      margin-left: 25px;
      text-align: center
    }
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0; 
    }
    input:focus{
        outline: none;
    }

</style>



// WEBPACK FOOTER //
// EditEmail.vue?0d4fdab8